import { api } from "../../../services/apiClient";
import type {
  HomeCoordinatorProjects,
  HomeScope,
  HomeSummary,
  HomeTracking,
} from "../types/home.types";

/** GET /project/home/summary — sem escopo, a Api usa o padrão do perfil. */
export async function getHomeSummary(scope?: HomeScope): Promise<HomeSummary> {
  const { data } = await api.get<HomeSummary>("/project/home/summary", {
    params: scope ? { scope } : {},
  });
  return data;
}

/** GET /project/home/tracking — fases, carga e movimentações do escopo. */
export async function getHomeTracking(
  scope?: HomeScope
): Promise<HomeTracking> {
  const { data } = await api.get<HomeTracking>("/project/home/tracking", {
    params: scope ? { scope } : {},
  });
  return data;
}

/** GET /project/home/coordinator-projects — até 5 projetos do coordenador. */
export async function getHomeCoordinatorProjects(
  scope: HomeScope,
  coordinator: string
): Promise<HomeCoordinatorProjects> {
  const { data } = await api.get<HomeCoordinatorProjects>(
    "/project/home/coordinator-projects",
    { params: { scope, coordinator } }
  );
  return data;
}
